import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface Profile {
  userId: string;
  name: string;
  email: string;
  tier?: string;
}

export default function Dashboard() {
  const { data: profile, isLoading, isError } = useQuery<Profile>({
    queryKey: ['profile'],
    queryFn: () => api.get<Profile>('/auth/profile'),
  });

  return (
    <div className="p-8 max-w-3xl">
      <div className="mb-8">
        {isLoading ? (
          <div className="h-8 w-48 bg-gray-200 animate-pulse rounded" />
        ) : isError ? (
          <h1 className="text-2xl font-semibold text-gray-900">Welcome back</h1>
        ) : (
          <h1 className="text-2xl font-semibold text-gray-900">
            Welcome back, {profile?.name.split(' ')[0]}
          </h1>
        )}
        <p className="mt-1 text-sm text-gray-500">Here's where your work lives.</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <ActionCard
          title="Resume"
          description="Upload your resume to get an ATS score and tailored improvements."
          href="/resume"
          cta="Get started"
        />
        <ActionCard
          title="Folio"
          description="Generate a personal presence site that ranks when someone Googles your name."
          href="/folio"
          cta="Set up Folio"
        />
      </div>
    </div>
  );
}

function ActionCard({
  title,
  description,
  href,
  cta,
}: {
  title: string;
  description: string;
  href: string;
  cta: string;
}) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 flex flex-col">
      <h2 className="text-base font-semibold text-gray-900 mb-1">{title}</h2>
      <p className="text-sm text-gray-600 flex-1 mb-4">{description}</p>
      <a
        href={href}
        className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-700"
      >
        {cta} →
      </a>
    </div>
  );
}
